const urls = {
 lelang: 'https://apigw-ext.bankmuamalat.co.id/lelangbmi',
 // lelang: 'http://localhost:29501/lelangbmi',
  pbi: 'http://localhost:19144/bmpp/glossary',
  users: 'http://localhost:19144/bmpp/user'
};

export default urls;
